export const hexToRgb = (hex: string): string => {
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex);
  if (!result) return '0, 0, 0';
  return `${Number.parseInt(result[1], 16)}, ${Number.parseInt(
    result[2],
    16,
  )}, ${Number.parseInt(result[3], 16)}`;
};

export const hexToRgba = (hex: string, alpha: number = 1): string => {
  return `rgba(${hexToRgb(hex)}, ${alpha})`;
};
